export const links = Object.freeze({
  googleMapSrc: `https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&q=Christ+Church%2C+Tudor+Way%2C+Petts+Wood%2C+Kent%2C+BR5+1LH&zoom=15`,
  joinBMM: 'https://www.cognitoforms.com/BromleyMusicMakers/BromleyMusicMakersApplicationForm',
  exampleProgramme: 'https://drive.google.com/file/d/1jynyHaorcY7W1J8xFp-SHSQxjmP51A1Q/view?usp=sharing',
  telMartinSharpe: 'tel:+4402084021947',
  emailBMM: 'mailto:bromleymusicmakers@gmail.com',
  emailMusicSec: 'mailto:loisjones958@gmail.com',
  emailSilky: 'mailto:silky.ng@gmail.com',
  googleMapShareLink: 'https://maps.app.goo.gl/g4Vp1p3S4mjQ276B8',
  joannaWhalleyYT: 'https://www.youtube.com/embed/G23ldo0uQjo?si=IbEMzq1bHnwHyFAL',
  trioYTPart1: 'https://www.youtube.com/embed/ck2XZwmpczk',
  trioYTPart2: 'https://www.youtube.com/embed/tLOFX9uopD8'
})
